import React from 'react'
import { Navigate } from 'react-router-dom'

const Login = () => <Navigate to="/" />

export default Login
